import React from 'react';
import { planningQuestions, sequenceSteps } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
export function Transformation() {
  return <section className="w-full bg-white px-5 py-16 md:py-24" data-id="element-306" data-mp="1nopot7xnnr4i">
      <div className="mx-auto max-w-5xl" data-id="element-307" data-mp="1iqecmqjw14j4">
        <SectionHeading title={<>
              From a case that feels complicated… <span className="italic text-sky" data-id="element-309" data-mp="2fh6untqdt6nj">to a plan you can see on one page.</span>
            </>} sub="You shouldn’t have to keep everything in your head when you’re planning a case." data-id="element-308" data-mp="1irfzdsa9nfgo" />

        <div className="mt-12 grid gap-10 md:grid-cols-[1fr_1.1fr] md:items-start" data-id="element-310" data-mp="26o3lhxmrrfyp">
          <div data-id="element-311" data-mp="26m0m4mzq8ahb">
            <h3 className="text-xl font-extrabold text-navy" data-id="element-312" data-mp="21pihro8b6e5i">Before you start moving teeth, you need to know:</h3>
            <ul className="mt-5 space-y-3" data-id="element-313" data-mp="2z4wf1fvzo4mq">
              {planningQuestions.map(q => <li key={q} className="flex items-start gap-3 text-[17px] font-medium text-navy" data-id="element-314" data-mp="2udxycf7394iy">
                  <div className="mt-0.5 h-5 w-5 shrink-0 text-sky" aria-hidden="true" data-id="element-315" data-mp="1586cpwd0xj9y" />
                  {q}
                </li>)}
            </ul>
            <p className="mt-5 text-[17px] text-muted" data-id="element-316" data-mp="1a5y5stpenbfq">This system helps you organize those decisions before you begin treatment.</p>
          </div>

          <div className="rounded-3xl bg-navy p-5 text-white md:p-8" data-id="element-317" data-mp="10hgagrzw9wjh">
            <p className="text-sm font-bold uppercase tracking-wider text-sky-light" data-id="element-318" data-mp="10fn2n9djp69w">The measurable transformation</p>
            <p className="mt-3 text-lg font-semibold" data-id="element-319" data-mp="mk1gd9yp50l6">Plan your next orthodontic case in</p>
            <p className="font-serif text-6xl font-black text-white md:text-7xl" data-id="element-320" data-mp="reovii7t8in3">15 minutes</p>
            <p className="mt-2 text-[17px] text-sky-light" data-id="element-321" data-mp="dj3aem4p6izy">using a structured treatment map instead of starting from a blank page.</p>

            <p className="mt-6 text-sm font-semibold text-white" data-id="element-322" data-mp="27vb1tpht8hqz">You will work through a repeatable sequence:</p>
            <ol className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-323" data-mp="2bwwillxgtg6g">
              {sequenceSteps.map((step, i) => <li key={step} className="flex items-center gap-2 whitespace-nowrap rounded-xl bg-navy-800 px-2.5 py-3 text-[13px] font-extrabold uppercase sm:text-sm" data-id="element-324" data-mp="3kttk4z5rgzxe" data-mpi={i}>
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sky text-[11px] text-white" data-id="element-325" data-mp="3bsvde93xueb4">
                    {i + 1}
                  </span>
                  {step}
                </li>)}
            </ol>
            <p className="mt-6 text-[17px] leading-relaxed text-sky-light" data-id="element-326" data-mp="7ddk9etcth98">
              The goal isn’t to replace clinical judgment.{' '}
              <strong className="text-white" data-id="element-327" data-mp="3ffvgd3hwx6d">The goal is to give your clinical judgment a structure to work with.</strong>
            </p>
          </div>
        </div>

        <div className="mt-12" data-id="element-328" data-mp="3ps4wphnfxojb">
          <CtaButton label="I want to plan with clarity" data-id="element-329" data-mp="3pqtqzcafq6pk" />
        </div>
      </div>
    </section>;
}